import {
  Component,
  Input,
  Output,
  EventEmitter,
  QueryList,
  ViewChildren,
  AfterViewInit,
  OnInit,
} from "@angular/core";
import { InputSelectorWithSearchComponent } from "../input-selector-with-search/input-selector-with-search.component";
import { SharedInfoService } from "src/app/core/services/sharedInfo.service";
import * as moment from "moment";
import { PreviousValuesOfFilters } from "src/app/core/models/filter-table-state.model";
import { FiltersTableStateService } from "src/app/core/services/filters-table-state.service";
import { Options, OptionsOutTable } from "./models/filters.model";

@Component({
  selector: "app-filters",
  templateUrl: "./filters.component.html",
  styleUrls: ["./filters.component.scss"],
})
export class FiltersComponent implements AfterViewInit, OnInit {
  @Input() filterList;
  @Input() options: Options | OptionsOutTable;
  @Input() type: string;
  @Input() titleOutTable: string = "Filtros ampliados";

  @Output() valueFilter = new EventEmitter<any>();
  @Output() showfilterButtons = new EventEmitter<any>();
  @Output() showFilters = new EventEmitter<"normal" | "outTable">();

  @ViewChildren("inputSearch")
  inputSearchList: QueryList<InputSelectorWithSearchComponent>;

  filtersValuesSearch = [];
  filtersSelectorSearch = [];

  public filtersToggled = false;

  constructor(
    private sharedService: SharedInfoService,
    private filtersTableStateService: FiltersTableStateService
  ) {}

  ngOnInit() {
    if (this.options && !this.options.style) {
      this.options.style = { "min-width": "1100px" };
    }

    this.getPreviousValuesFilters();
  }

  private getPreviousValuesFilters(): void {
    let type: "normal" | "outTable" =
      this.options && this.options.isOutTable ? "outTable" : "normal";
    if (
      this.filtersTableStateService.checkIfIsSameScreen(this.filterList, type)
    ) {
      if (this.options && this.options.isOutTable) {
        this.filtersValuesSearch =
          this.filtersTableStateService.getPreviousValuesOfFiltersOutTable();
        this.filtersSelectorSearch =
          this.filtersTableStateService.getPreviousValuesOutTableOfFiltersSelector();
        if (this.checkIfHasValues()) {
          this.filtersToggled = true;
          this.showFilters.emit(type);
        }
      } else {
        this.filtersValuesSearch =
          this.filtersTableStateService.getPreviousValuesOfFilters();
        this.filtersSelectorSearch =
          this.filtersTableStateService.getPreviousValuesOfFiltersSelector();
        if (this.checkIfHasValues()) {
          this.showFilters.emit(type);
        }
      }
    } else {
      let dto: PreviousValuesOfFilters = {
        filterList: [],
        filtersValuesSearch: [],
        filtersSelectorSearch: [],
      };
      this.filtersTableStateService.setPreviousValuesOfFilters(dto);
      this.filtersTableStateService.setPreviousValuesOfFiltersOutTable(dto);
      this.filterList.forEach((element) => {
        if (element.multiple === true) {
          element.secondField.value = "";
        }
      });
    }
  }

  ngAfterViewInit(): void {}

  private checkIfHasValues(): boolean {
    let anyValueSelector = this.filtersSelectorSearch.filter(
      (field) => field.value !== null && field.value !== undefined
    );
    let anyFilterValue = this.filtersValuesSearch.filter(
      (value) => value && value !== ""
    );
    if (anyFilterValue.length > 0 || anyValueSelector.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  private saveFilters() {
    let values: PreviousValuesOfFilters = {
      filterList: this.filterList,
      filtersValuesSearch: this.filtersValuesSearch,
      filtersSelectorSearch: this.filtersSelectorSearch,
    };
    if (this.options && this.options.isOutTable) {
      this.filtersTableStateService.setPreviousValuesOfFiltersOutTable(values);
    } else {
      this.filtersTableStateService.setPreviousValuesOfFilters(values);
    }
  }

  public composeParams(): string {
    this.saveFilters();
    let value = "";
    this.filterList.forEach((element, index) => {
      if (
        element["filterValue"] &&
        this.filtersValuesSearch[index] !== undefined &&
        this.filtersValuesSearch[index] !== null &&
        this.filtersValuesSearch[index] !== ""
      ) {
        if (value.length == 0) {
          value =
            value +
            "_" +
            element["filterValue"] +
            "=" +
            encodeURI(this.filtersValuesSearch[index]);
        } else {
          value =
            value +
            "&_" +
            element["filterValue"] +
            "=" +
            encodeURI(this.filtersValuesSearch[index]);
        }
      }
      value = this.checkAndAddMultipleFilters(value, element);
    });
    value = this.composeSelectorSearch(value);
    return value;
  }

  composeParamsTwoArrays(): any {
    this.saveFilters();
    let result: any = {
      arrayKeys: [],
      arrayValues: [],
    };
    this.filterList.forEach((element, index) => {
      if (
        element["filterValue"] &&
        this.filtersValuesSearch[index] !== undefined &&
        this.filtersValuesSearch[index] !== null &&
        this.filtersValuesSearch[index] !== ""
      ) {
        if (element.type === "date") {
          result.arrayKeys.push(element["filterValue"]);
          const fechaObjeto = moment(
            this.filtersValuesSearch[index],
            "YYYY-MM-DD"
          );

          const fechaFormateada = fechaObjeto.format("DD/MM/yyyy");
          result.arrayValues.push(fechaFormateada);
        } else {
          result.arrayKeys.push(element["filterValue"]);
          result.arrayValues.push(this.filtersValuesSearch[index]);
        }
      }
    });

    return result;
  }

  valueSelector(value) {
    const exist = (element) => element.key == value.id;
    let pos = this.filtersSelectorSearch.findIndex(exist);
    if (pos == -1) {
      this.filtersSelectorSearch.push({ key: value.id, value: value.item });
    } else {
      this.filtersSelectorSearch[pos].value = value.item;
    }
  }

  composeSelectorSearch(value: string): string {
    let filterListSelectors = this.filterList.filter(
      (element) => element["type"] == "select"
    );
    this.filtersSelectorSearch.forEach((element, index) => {
      if (element.value && element.value[element.key] !== "") {
        let pos = filterListSelectors.findIndex(
          (e) => e["selectorConf"]["id"] == element.key
        );
        if (value == "") {
          value =
            value +
            "_" +
            filterListSelectors[pos]["filterValue"] +
            "=" +
            element.value[element.key];
        } else {
          value =
            value +
            "&_" +
            filterListSelectors[pos]["filterValue"] +
            "=" +
            element.value[element.key];
        }
      }
    });
    return value;
  }

  checkAndAddMultipleFilters(value, element): string {
    if (
      element.multiple &&
      element.secondField &&
      element.secondField.value !== ""
    ) {
      if (value.length == 0) {
        value =
          value +
          "_" +
          element.secondField["filterValue"] +
          "=" +
          element.secondField.value;
      } else {
        value =
          value +
          "&_" +
          element.secondField["filterValue"] +
          "=" +
          element.secondField.value;
      }
    }
    return value;
  }

  cleanSelectorAndDates() {
    this.inputSearchList.toArray().forEach((e) => {
      e.item = "";
    });
    this.filterList.forEach((e) => {
      if (e["secondField"]) {
        e["secondField"]["value"] = "";
      }
    });
  }

  toggleFilterButton() {
    this.filtersToggled = !this.filtersToggled;
    this.showfilterButtons.emit(this.filtersToggled);
  }

  public pressEnter(): void {
    this.sharedService.sendMessage("search");
  }

  public getValueOfSelector(item: any): any {
    let element = this.filtersSelectorSearch.find(
      (e) => e.key === item.selectorConf.id
    );
    if (element) {
      return element.value;
    } else {
      return "";
    }
  }
}
